document.addEventListener("DOMContentLoaded", function() {

    /* =========================================================
       Generic Carousel Controls for IH + TS product sections
       ========================================================= */

    document.querySelectorAll('.ih-carousel-wrapper, .ts-carousel-wrapper').forEach(function(wrapper) {
        const carousel = wrapper.querySelector('.ih-carousel, .ts-carousel');
        const btnRight = wrapper.querySelector('.ih-arrow-right, .ts-arrow-right');
        const btnLeft = wrapper.querySelector('.ih-arrow-left, .ts-arrow-left');

        if (!carousel) return;

        function getScrollAmount() {
            return carousel.clientWidth * 0.75;
        }

        if (btnLeft) {
            btnLeft.addEventListener('click', function() {
                carousel.scrollBy({
                    left: -getScrollAmount(),
                    behavior: 'smooth'
                });
            });
        }

        if (btnRight) {
            btnRight.addEventListener('click', function() {
                carousel.scrollBy({
                    left: getScrollAmount(),
                    behavior: 'smooth'
                });
            });
        }
    });


    /* =========================================================
       Tabs for TS product tabs section
       ========================================================= */

    document.querySelectorAll('.ts-tabs-section').forEach(function(section) {
        const buttons = section.querySelectorAll('.ts-tab-btn');
        const panes = section.querySelectorAll('.ts-tab-pane');

        buttons.forEach(function(button) {
            button.addEventListener('click', function() {
                const targetId = button.getAttribute('data-target');
                const targetPane = section.querySelector('#' + targetId);

                buttons.forEach(function(btn) {
                    btn.classList.remove('active');
                });

                panes.forEach(function(pane) {
                    pane.classList.remove('active');
                });

                button.classList.add('active');

                if (targetPane) {
                    targetPane.classList.add('active');
                }
            });
        });
    });


    /* =========================================================
       AJAX Add To Cart for IH + TS product sections
       ========================================================= */

    document.addEventListener('submit', async function(e) {
        if (!(e.target instanceof Element)) return;

        const form = e.target.closest('.ts-add-cart-form');

        if (!form) return;

        e.preventDefault();

        const button = form.querySelector('.ih-add-cart-btn, .ts-add-cart-btn');
        const originalText = button ? button.textContent.trim() : 'أضف إلى السلة';

        if (button) {
            button.disabled = true;
            button.textContent = 'جاري الإضافة...';
        }

        try {
            const formData = new FormData(form);

            const addResponse = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: formData
            });

            if (!addResponse.ok) {
                const errorData = await addResponse.json().catch(function() {
                    return {};
                });

                throw new Error(
                    errorData.description ||
                    errorData.message ||
                    'تعذر إضافة المنتج إلى السلة'
                );
            }

            await addResponse.json();

            const cartResponse = await fetch('/cart.js', {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                }
            });

            const cart = await cartResponse.json();

            updateCartCount(cart.item_count);
            refreshThemeCart(cart);

            if (button) {
                button.textContent = 'تمت الإضافة';
            }

            setTimeout(function() {
                openHeaderCart();

                if (button) {
                    button.textContent = originalText;
                }
            }, 300);

        } catch (error) {
            console.error(error);

            if (button) {
                button.textContent = originalText;
            }

            alert(error.message || 'حدث خطأ أثناء إضافة المنتج إلى السلة');
        } finally {
            if (button) {
                setTimeout(function() {
                    button.disabled = false;
                }, 500);
            }
        }
    });


    function updateCartCount(count) {
        const countSelectors = [
            '[data-cart-count]',
            '[data-js-cart-count]',
            '.cart-count',
            '.cart-count-bubble span',
            '.header__cart-count',
            '.cart-items-count',
            '.js-cart-count',
            '.minicart-count'
        ];

        countSelectors.forEach(function(selector) {
            document.querySelectorAll(selector).forEach(function(el) {
                el.textContent = count;
                el.classList.remove('d-none', 'hidden');
            });
        });
    }


    function refreshThemeCart(cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { cart: cart }
        }));

        document.dispatchEvent(new CustomEvent('cart:update', {
            detail: { cart: cart }
        }));

        document.dispatchEvent(new CustomEvent('cart:refresh', {
            detail: { cart: cart }
        }));

        document.dispatchEvent(new CustomEvent('ajaxCart:updated', {
            detail: { cart: cart }
        }));

        window.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { cart: cart }
        }));

        window.dispatchEvent(new CustomEvent('cart:refresh', {
            detail: { cart: cart }
        }));
    }


    function openHeaderCart() {
        const cartTrigger = document.querySelector(
            '.box-minicart a.push_side.header-icon[data-id="#js_cart_popup"], ' +
            'a.push_side.header-icon[data-id="#js_cart_popup"], ' +
            '.push_side[data-id="#js_cart_popup"], ' +
            '[data-id="#js_cart_popup"]'
        );

        if (cartTrigger) {
            cartTrigger.dispatchEvent(new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window
            }));

            return;
        }

        const cartPopup = document.querySelector('#js_cart_popup');

        if (cartPopup) {
            cartPopup.classList.add('active', 'open', 'is-open', 'opened');
            cartPopup.setAttribute('open', 'open');

            document.body.classList.add(
                'open_cart',
                'cart-open',
                'drawer-open',
                'push_side_open',
                'open-sidebar'
            );

            document.documentElement.classList.add(
                'open_cart',
                'cart-open',
                'drawer-open',
                'push_side_open',
                'open-sidebar'
            );
        }
    }

});